var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 26.878,
    viewBox: "0 0 30 26.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "modules"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M26.526,0H3.453A3.459,3.459,0,0,0,0,3.453V23.425a3.459,3.459,0,0,0,3.453,3.453H26.547A3.459,3.459,0,0,0,30,23.425V3.453A3.49,3.49,0,0,0,26.526,0M14.99,15.589a4.6,4.6,0,0,1-4.425-4.735A4.6,4.6,0,0,1,14.99,6.12a4.57,4.57,0,0,1,4.425,4.735,4.583,4.583,0,0,1-4.425,4.735m1.282,1.9a7.489,7.489,0,0,1,7.23,7.484H6.477a7.488,7.488,0,0,1,7.23-7.484ZM28.1,23.425h-.021a1.562,1.562,0,0,1-1.551,1.551H25.4a9.583,9.583,0,0,0-6.461-8.967,6.747,6.747,0,0,0,2.373-5.175A6.491,6.491,0,0,0,14.99,4.2a6.491,6.491,0,0,0-6.327,6.637,6.748,6.748,0,0,0,2.373,5.175,9.582,9.582,0,0,0-6.461,8.966H3.453A1.562,1.562,0,0,1,1.9,23.425V3.453A1.562,1.562,0,0,1,3.453,1.9H26.547A1.562,1.562,0,0,1,28.1,3.453Z",
    fill: "#466dec"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModules);
export default __webpack_public_path__ + "static/media/Modules.b053597bb8cccd4113b26ac326ff312f.svg";
export { ForwardRef as ReactComponent };